import { useEffect, useState } from "react";

import { ISensor } from "../models/Sensors";
import config from "../config";
import { go } from "fuzzysort";
import { excludeDuplicateAlert1Sensors } from "../layers/duplicateSensors";
import { isPrecipSensor } from "../models/PrecipSensor";
import { isStreamSensor } from "../models/StreamSensor";
import { useRootStore } from "../models/Root";

const useFindSensors = (find: string) => {
  interface FindSensorsResult extends Fuzzysort.KeyResults<ISensor> {}
  const [results, setResults] = useState<FindSensorsResult>();

  const {
    sensors: { sensors },
  } = useRootStore();

  useEffect(() => {
    const opts = { key: "site", limit: 3 };
    const sensorList = Array.from(sensors.values());
    const candidates =
      config.markers.precip.duplicateSiteExpandZoomLevel === false
        ? sensorList
        : [
            ...excludeDuplicateAlert1Sensors(
              sensorList.filter(isPrecipSensor)
            ),
            ...excludeDuplicateAlert1Sensors(
              sensorList.filter(isStreamSensor)
            ),
          ];
    const results_ = go(find, candidates, opts);
    setResults(results_);
  }, [find, sensors]);

  return results;
};

export default useFindSensors;
